// extracted by mini-css-extract-plugin
export default {"cabecalho":"styles_cabecalho__10zsT","group":"styles_group__3R8UM","document":"styles_document__6uLYh","bank":"styles_bank__OCbiv","hands":"styles_hands__r5TIt"};